import { Skeleton, Space } from 'antd'

/**
 * Jadval uchun skeleton — SPINNER EMAS.
 *
 * NEGA: skeleton kelayotgan tarkibning shaklini oldindan ko'rsatadi, shu
 * sababli birinchi yuklashda sahifa "sakramaydi" va kutish qisqaroq
 * seziladi. Keyingi yangilanishlarda (sahifalash, filtr) esa jadval
 * o'zining `loading` xususiyati bilan yengil spinnerni ko'rsatadi — u yerda
 * shakl allaqachon ma'lum, skeleton keraksiz.
 */
export function TableSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <Space direction="vertical" style={{ width: '100%' }} size={12}>
      <Skeleton.Input active block style={{ height: 38 }} />
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton.Input key={index} active block style={{ height: 44 }} />
      ))}
    </Space>
  )
}
